/**
 * Reading a cellar for the CSV export from outside that cellar (T097, the person's settings):
 * the latest stored document, or an empty cellar when the person has none yet, so the export
 * still gives the header line (spec.md User Story 11, Acceptance 5).
 */
import type { Cellar } from '../domain/cellar';
import { CellarNotFoundError, createCellarStore } from './cellar-store';
import type { ObjectStorage } from './fake-storage';

export async function loadCellarForExport(
  storage: ObjectStorage,
  cellarId: string,
): Promise<Cellar | undefined> {
  try {
    return await createCellarStore(storage, cellarId, { createIfMissing: false }).load();
  } catch (error) {
    if (error instanceof CellarNotFoundError) return undefined;
    throw error;
  }
}
